
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import GlobalFaqSection from "@/components/shared/GlobalFaqSection";
import SEO from "@/components/SEO";
import { useEffect } from "react";
import useMetaTracking from "@/hooks/use-meta-tracking";

const Faq = () => {
  const { trackViewContent } = useMetaTracking();

  // Track page view for analytics
  useEffect(() => {
    trackViewContent({
      content_name: "faq",
      content_category: "support_page"
    });
  }, [trackViewContent]);

  const faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://drcash.com.br/faq"
    },
    "description": "Página de perguntas frequentes da Dr.Cash, com respostas para dúvidas sobre financiamento, plataforma, pagamentos, contratação e antecipação de recebíveis."
  };

  return (
    <>
      <SEO 
        title="Perguntas Frequentes | Dr.Cash - Soluções financeiras para clínicas de saúde"
        description="Encontre respostas para as principais dúvidas sobre financiamento médico, boleto parcelado, acesso à plataforma, pagamentos e mais."
        keywords="faq drcash, perguntas frequentes dr.cash, dúvidas financiamento médico, boleto parcelado saúde, suporte drcash"
        structuredData={faqStructuredData}
      />
      <Navbar />
      <main>
        <div className="pt-28 pb-16">
          <GlobalFaqSection 
            title="Central de Perguntas Frequentes"
            subtitle="Encontre respostas para todas as suas dúvidas sobre nossos serviços e produtos"
            showSearch={true}
            showCategories={true}
            defaultCategory="all"
            className="bg-gray-50"
          />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Faq;
